// extracted by mini-css-extract-plugin
module.exports = {"RichText":"RichText_RichText__lXCFw","RichText___bigText":"RichText_RichText___bigText__CPRiN","RichText___truncateText":"RichText_RichText___truncateText__yN7RY"};